<template>
  <p>Page Not Found</p>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue